import { connect } from 'react-redux';
import type { WUploadedImageView } from '@zola/svc-web-api-ts-client';

import { saveUploadcareImageToZola, fetchZolaMetadata } from 'actions/UploadcareActions';
import { getCachedMetadata } from 'selectors/uploadcareSelectors';

import { fileUploaded } from 'actions/FileUploadActions';
import type { FileUploadActionTypes } from 'actions/types/FileUploadActionTypes';
import type { AppDispatch, RootState } from '../../../reducers';

import ImageUpload from './ImageUpload';

export type ImageUploadStateProps = {
  cachedMetadata: {
    [k: string]: WUploadedImageView;
  };
};

const mapStateToProps = (state: RootState): ImageUploadStateProps => ({
  cachedMetadata: getCachedMetadata(state),
});

export type ImageUploadDispatchProps = {
  copyImageToZola: (
    uploadcareFile: WUploadedImageView,
    cache: ImageUploadStateProps['cachedMetadata']
  ) => Promise<WUploadedImageView>;
  loadCache: (zolaImageId: string) => Promise<void>;
  zolaFileUploaded: (zolaFile: WUploadedImageView) => FileUploadActionTypes;
};

const mapDispatchToProps = (dispatch: AppDispatch): ImageUploadDispatchProps => ({
  copyImageToZola: (uploadcareFile, cache): Promise<WUploadedImageView> =>
    dispatch(saveUploadcareImageToZola(uploadcareFile, cache)),
  loadCache: (zolaImageId): Promise<void> => dispatch(fetchZolaMetadata(zolaImageId)),
  zolaFileUploaded: (zolaFile): FileUploadActionTypes => dispatch(fileUploaded(zolaFile)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageUpload);



// WEBPACK FOOTER //
// ./src/components/common/ImageUpload/index.ts